import type { ToolbarDesignTokens } from '@primeuix/themes/types/toolbar';

export default {
    root: {
        background: 'transparent',
        borderColor: '{content.border.color}',
        borderRadius: '{content.border.radius}',
        color: '{content.color}',
        gap: '0.5rem',
        padding: '0.5rem',
    },
} satisfies ToolbarDesignTokens;
